module.exports = __webpack_public_path__ + "img/Plastering-cropt.cde9ecd0.png";